﻿import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  projectRole: "projectRole",
};

export const projectRoleApi = createApi({
  reducerPath: "projectRoleApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "admin/project-roles",
  }),
  keepUnusedDataFor: NO_CACHING,
  tagTypes: [TAG_TYPES.projectRole],
  endpoints: (build) => ({
    searchProjectRoles: build.query({
      query: (queryParameters) => ({
        url: appendQueryParameters("search", queryParameters),
      }),
    }),
    getProjectRole: build.query({
      query: (id) => id,
      transformResponse: ({ data }) => data,
      providesTags: [TAG_TYPES.projectRole],
    }),
    getProjectRoles: build.query({
      query: () => "",
      transformResponse: ({ data }) => data,
    }),
    createProjectRole: build.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      transformResponse: ({ data }) => data,
    }),
    saveProjectRole: build.mutation({
      query: (data) => ({
        url: data.id,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [TAG_TYPES.projectRole],
    }),
    deleteProjectRole: build.mutation({
      query: (id) => ({
        url: id,
        method: "DELETE",
      }),
    }),
    suggestProjectRoles: build.mutation({
      query: ({
        query,
        includeEmptyProjectType,
        excludedExistingRoles,
        maxResults = 25,
      }) => ({
        url: "suggestions",
        method: "POST",
        body: {
          Query: query,
          ExcludedProjectRoles: excludedExistingRoles,
          IncludeEmptyProjectType: includeEmptyProjectType,
          Top: maxResults,
        },
      }),
      transformResponse: ({ data }) => data,
    }),
    updateProjectRoleActiveState: build.mutation({
      query: ({ id, isActive, removeAndDeactivate }) => ({
        url: `${id}/state`,
        method: "PUT",
        body: {
          IsActive: isActive,
          RemoveAndDeactivate: removeAndDeactivate,
        },
      }),
      transformResponse: ({ data }) => data,
    }),
    getProjectRolesByIds: build.mutation({
      query: (ids) => ({
        url: "ids",
        method: "POST",
        body: {
          ids,
        },
      }),
      transformResponse: ({ data }) => data,
    }),
    getDefaultRolesForUser: build.query({
      query: (id) => `${id}/defaults`,
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const {
  useSearchProjectRolesQuery,
  useGetProjectRoleQuery,
  useGetProjectRolesQuery,
  useUpdateProjectRoleActiveStateMutation,
  useCreateProjectRoleMutation,
  useSaveProjectRoleMutation,
  useDeleteProjectRoleMutation,
  useSuggestProjectRolesMutation,
  useGetProjectRolesByIdsMutation,
  useGetDefaultRolesForUserQuery,
} = projectRoleApi;
